import { FALLBACK_WIDGET, FallbackWidget } from './FallbackWidget/FallbackWidget';
export const coreWidgets = {
  data: {
    [FALLBACK_WIDGET]: [FALLBACK_WIDGET, FallbackWidget]
  },
  getNames() {
    return Object.keys(this.data);
  },
  getComponents() {
    return Object.values(this.data);
  }
};
//# sourceMappingURL=index.js.map